import { render, staticRenderFns } from "./SettingsCurrency.vue?vue&type=template&id=9b931dc0"
import script from "./SettingsCurrency.vue?vue&type=script&lang=js"
export * from "./SettingsCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports